






























































    import { Component } from "vue-property-decorator";
    import { Guid } from 'guid-typescript';
    
    import { mixins } from "vue-class-component";
    import SharedMixin from "@/mixins/SharedMixin";
    
    import { InternalProjectStore } from "../../../InternalProjectStore";
    import { SectionStore } from "../../../SectionStore";
    import { BusinessLineTableView, TechAreaModel, TipologiaFornituraModel } from "@/services/iOrderService";

    @Component({})
    export default class PgaOfferEvaluationHeaderInternalProjectEdit extends mixins(SharedMixin)
    {
        get title() : string
        {
            return InternalProjectStore.EditInternalProjectHeader.Command.Title;
        }
        set title(value: string)
        {
            InternalProjectStore.SET_EDIT_INTERNALPROJECT_HEADER_TITLE(value);
        }

        get date() : Date
        {
            return InternalProjectStore.EditInternalProjectHeader.Command.Date;
        }
        set date(value: Date)
        {
            InternalProjectStore.SET_CREATE_INTERNALPROJECT_HEADER_DATE(value);
        }

        get businessLine() : Guid | null
		{
			return InternalProjectStore.EditInternalProjectHeader.Command.BusinessLineId;
		}
		set businessLine(value: Guid | null)
		{
			InternalProjectStore.SET_CREATE_INTERNALPROJECT_HEADER_TECHAREAID(null);
			InternalProjectStore.SET_CREATE_INTERNALPROJECT_HEADER_BUSINESSLINEID(value);
		}

		get techArea() : Guid | null
		{
			return InternalProjectStore.EditInternalProjectHeader.Command.TechAreaId;
		}
		set techArea(value: Guid | null)
		{
			InternalProjectStore.SET_CREATE_INTERNALPROJECT_HEADER_TECHAREAID(value);
		}

		get supplyTipology() : Guid | null
		{
			return InternalProjectStore.EditInternalProjectHeader.Command.SupplyTipologyId;
		}
		set supplyTipology(value: Guid | null)
		{
			InternalProjectStore.SET_CREATE_INTERNALPROJECT_HEADER_SUPPLYTIPOLOGYID(value);
		}

        //Dropdown Lists
		get businessLineDropdown() : Array<BusinessLineTableView>
		{
			return SectionStore.BusinessLinesDropdown;
		}
		get techAreaDropdown() : Array<TechAreaModel>
		{		
			return SectionStore.TechAreasDropdown.filter(ta => ta.BusinessLine.Id === this.businessLine);
		}
		get supplyTipologyDropdown() : Array<TipologiaFornituraModel>
		{
			return SectionStore.SupplyTipologiesDropdown.filter(st => st.Code == "02" || st.Code == "03");
		}

        get Errors() : Map<string, Array<string>>
        {
            return InternalProjectStore.EditInternalProjectHeader.Errors;
        }

        beforeDestroy() : void
        {
            InternalProjectStore.SET_EDIT_INTERNALPROJECT_HEADER_ERRORS(new Map<string, Array<string>>());
            InternalProjectStore.ResetEditInternalProjectCommand();
        }
    }
